import { Component, OnInit } from '@angular/core';
import { CompanyInfoStateService } from '../../services/company-info-state.service';
import { CompanyWorkingHours } from '../../models/company-working-hours';
import { LocalizationService } from '../../../../services/localization.service';

@Component({
  selector: 'app-company-schedule',
  templateUrl: './company-schedule.component.html',
  styleUrls: ['./company-schedule.component.css']
})
export class CompanyScheduleComponent implements OnInit {

  constructor(
    private companyInfoStateService: CompanyInfoStateService,
    private localizationService: LocalizationService,
  ) { }

  ngOnInit() {
    this.companyInfoStateService.initializeCompanySchedule().subscribe();
  }

  get companySchedule(): CompanyWorkingHours[] {
    return this.companyInfoStateService.companySchedule;
  }

  getWeekDayName(dayIndex: number): string {
    return this.localizationService.getWeekdayNameLongByIndex(dayIndex);
  }

  isTodayClass(dayIndex: Number): string {
    const todayIndex = this.localizationService.getTodayIndex();
    if (todayIndex === dayIndex) {
      return 'primary';
    }
    return '';
  }
}
